<template>
	<div class="small-12 addForm addRent animated fadeInRight border-top border-right" v-if="open_menu" v-bind:class="{ active: open_menu }">
		<div class="small-12 columns panelMenuWrapper" v-if="rent">
			<div class="small-12 formTitle border-bottom">
				<h2 class="small-12 flex vertical-align justify-between">
					<span class="float-left small-8">
						Edit Rent Term
					</span>
					<i class="material-icons-outlined transition" @click="closeEditRentMenu()">cancel</i>
				</h2>
				<div class=	"small-12">
					<ul class="small-12 flex vertical-align float-left attributes">
						<li>
							<p>
								<b>Term: </b>
								{{rent.attributes.term_dates.starting_at | unixToDate}} - {{rent.attributes.term_dates.ending_at | unixToDate}}
							</p>
						</li>
						<li class="small-12 flex vertical-align" style="margin:10px 0 0 0;">
							<span class="badge borderRadius4 bgPrimaryBlue" v-if="edited_rent.term.value == 'current'">Current</span>
							<span class="badge borderRadius4 bgGrey" v-else-if="edited_rent.term.value == 'future'">Future</span>
							<span class="badge borderRadius4 bgSecondaryPurple" v-else>Past</span>
						</li>
					</ul>
				</div>	
			</div>
			<div class="small-12 formBody" style="padding-top:20px;" v-if="rent_options">
				<div class="small-12 informationalBreakdown border light borderRadius4" v-if="rent.attributes.term == 'past'">
					<p class="small-12 columns">
						<b>Please Note:</b> 
						This rent term is unable to be edited because it is now 
						in the past.
					</p>
				</div>	
				<div class="small-12 sectionTitle flex" style="margin-top:0;">
					<h2>Type</h2>
				</div>
				<fieldset class="small-12 flex inputGroup">
					<label class="small-12">Rent Term Type<em class="cRed">*</em></label>
					<div class="small-12 selectContainer borderRadius8 flex vertical-align" v-if="rent.attributes.term !== 'past'">
						<select name="resident" class="small-12" v-model="edited_rent.term.value">
							<option :value="null" selected disabled>Please Choose...</option>
							<option :value="type.value" v-for="(type, typeIndex) in rent_options.statuses" :selected="edited_rent.term.value == type.value ? true : false" :key="typeIndex">{{type.title}}</option>
						</select>
					</div>
					<div class="small-12" v-else>
						<input type="text" class="small-12 disabled" disabled value="Past" style="margin-bottom:0;">
					</div>
					<div class="small-12 inputError flex animated fadeInDown borderRadius2" style="margin-top:5px;" v-if="edited_rent.term.error.show">
						<small class="cRed small-12">{{edited_rent.term.error.title}}</small>
					</div>
				</fieldset>
				<div class="small-12 sectionTitle flex">
					<h2>Rent Term</h2>
				</div>
				<fieldset class="small-12 flex inputGroup">
					<label class="small-12">Beginning On<em class="cRed">*</em></label>
					<div class="small-12" @click="setCalendarPickerIndex($event)" v-if="rent.attributes.term !== 'past' && edited_rent.starting_at.value">
						<datetime v-model="edited_rent.starting_at.value" value-zone="local" zone="local" :phrases="{ok: 'Select', cancel: 'Cancel'}" :format="{ month: 'numeric', day: 'numeric', year: 'numeric' }" @input="calculateCharges($event)"></datetime>
					</div>
					<input type="text" class="disabled" disabled v-model="edited_rent.starting_at.display_value" v-else>
					<div class="small-12 inputError flex animated fadeInDown" style="margin-top:5px;" v-if="edited_rent.starting_at.error.show">
						<small class="cRed small-12">{{edited_rent.starting_at.error.title}}</small>
					</div>
					<label class="small-12">Ending On<em class="cRed">*</em></label>
					<div class="small-12" @click="setCalendarPickerIndex($event)" v-if="rent.attributes.term !== 'past' && edited_rent.ending_at.value">
						<datetime v-model="edited_rent.ending_at.value" value-zone="local" zone="local" :phrases="{ok: 'Select', cancel: 'Cancel'}" :format="{ month: 'numeric', day: 'numeric', year: 'numeric' }" @input="calculateCharges($event)"></datetime>
					</div>
					<input type="text" class="disabled" disabled v-model="edited_rent.ending_at.display_value" v-else>
					<div class="small-12 inputError flex animated fadeInDown" style="margin-top:5px;" v-if="edited_rent.ending_at.error.show">
						<small class="cRed small-12">{{edited_rent.ending_at.error.title}}</small>
					</div>
				</fieldset>
				<div class="small-12 sectionTitle flex">
					<h2>Amount</h2>
				</div>
				<fieldset class="small-12 flex inputGroup">
					<label class="small-12">Amount (USD)<em class="cRed">*</em></label>
					<div class="small-12 addOnContainer borderRadius8">
						<input class="inputAddition" type="number" step="0.01" name="rent_amount" placeholder="0.00" @input="calculateEstimatedFees()" v-model="edited_rent.amount.value" v-if="rent.attributes.term !== 'past'">
						<input class="inputAddition disabled" type="number" step="0.01" name="rent_amount" placeholder="0.00" v-model="edited_rent.amount.display_value" disabled v-else>
						<div class="add-on borderRadius8">
							<i class="material-icons-outlined">attach_money</i>
						</div>
					</div>
					<div class="small-12 inputError flex animated fadeInDown" style="margin-top:5px;" v-if="edited_rent.amount.error.show">
						<small class="cRed small-12">{{edited_rent.amount.error.title}}</small>
					</div>
				</fieldset>
				<div class="small-12 sectionTitle flex">
					<h2>Rent Policy</h2>
				</div>
				<fieldset class="small-12 flex inputGroup">
					<label class="small-12">Rent Cycle<em class="cRed">*</em></label>
					<div class="small-12 selectContainer borderRadius8 flex vertical-align" v-if="rent_options && rent.attributes.term !== 'past'">
						<select name="rent_cycle" class="small-12" v-model="edited_rent.cycle.value" @change="calculateCharges($event)">
							<option :value="null" selected disabled>Please Choose...</option>
							<option :value="typeOption.value" v-for="(typeOption, typeOptionIndex) in rent_options.rent_cycles" :key="typeOptionIndex" :selected="edited_rent.cycle.value == typeOption.value ? true : false">{{typeOption.title}}</option>
						</select>
					</div>
					<input type="text" class="disabled" disabled v-model="edited_rent.cycle.display_value" v-else>
					<div class="small-12 flex vertical-align">
						<div class="small-12 large-6 columns" style="padding-left:0;">
							<label class="small-12">Due On The<em class="cRed">*</em></label>
							<div class="small-12 selectContainer borderRadius8 flex vertical-align" v-if="rent_options && rent.attributes.term !== 'past'">
								<select name="rent_cycle" class="small-12" v-model="edited_rent.due_on.value" @change="populateDueOn($event)">
									<option :value="null" selected disabled>Please Choose...</option>
									<option :value="typeOption.value" v-for="(typeOption, typeOptionIndex) in rent_options.due_on" :key="typeOptionIndex" :selected="edited_rent.due_on.value == typeOption.value ? true : false">{{typeOption.title}}</option>
								</select>
							</div>
							<input type="text" class="disabled" disabled v-model="edited_rent.due_on.display_value" v-else>
						</div>
						<div class="small-12 large-6 columns" style="padding-right:0;">
							<label class="small-12">Late By The</label>
							<div class="small-12 selectContainer borderRadius8 flex vertical-align" v-if="rent_options && rent.attributes.term !== 'past'">
								<select name="rent_cycle" class="small-12" v-model="edited_rent.late_by.value" @change="enableSubmitButtonCheck()">
									<option :value="null" selected disabled>Please Choose...</option>
									<option :value="typeOption.value" v-for="(typeOption, typeOptionIndex) in rent_options.due_on" :key="typeOptionIndex" :selected="edited_rent.late_by.value == typeOption.value ? true : false">{{typeOption.title}}</option>
								</select>
							</div>
							<input type="text" class="disabled" disabled v-model="edited_rent.late_by.display_value" v-else>
						</div>
					</div>
					<label class="small-12">Post (number of days in advance)</label>
					<div class="small-12 selectContainer borderRadius8 flex vertical-align" v-if="rent_options && rent.attributes.term !== 'past'">
						<select name="rent_cycle" class="small-12" v-model="edited_rent.days_in_advance.value" @change="enableSubmitButtonCheck()">
							<option :value="null" selected disabled>Please Choose...</option>
							<option :value="option" v-for="(option, index) in 30" :key="index" :selected="edited_rent.days_in_advance.value == option ? true : false">{{option}}</option>
						</select>
					</div>
					<input type="text" class="disabled" disabled v-model="edited_rent.days_in_advance.display_value" v-else>
					<label class="small-12">Late Fee (USD)</label>
					<div class="small-12 addOnContainer borderRadius8">
						<input class="inputAddition" type="number" step="0.01" name="late_fee" placeholder="0.00" v-model="edited_rent.late_fee.value" @keyup="lateFeeValidation()" v-if="rent.attributes.term !== 'past'">
						<input class="inputAddition disabled" type="number" step="0.01" name="late_fee" placeholder="0.00" disabled v-model="edited_rent.late_fee.display_value" v-else>
						<div class="add-on borderRadius8">
							<i class="material-icons-outlined">attach_money</i>
						</div>
					</div>
					<div class="small-12 inputError flex animated fadeInDown" style="margin-top:5px;" v-if="edited_rent.late_fee.error.show">
						<small class="cRed small-12">{{edited_rent.late_fee.error.title}}</small>
					</div>
				</fieldset>
				<div class="small-12 sectionTitle flex" v-if="payment_method_set">
					<h2>Transaction Fees</h2>
				</div>
				<div class="small-12 rentFeesBreakdown border borderRadius4 light" v-if="payment_method_set">
					<h2 class="small-12 border-bottom">The below fees are estimates only. Once a resident has made a payment, the actual fees will be available on the invoice.</h2>
					<div class="small-12 columns">
						<p class="small-12 flex vertical-align" v-if="company.attributes.settings.payment_methods.cards">
							<b class="small-8 text-right">Stripe Card Fee:</b> 
							<span class="small-4 text-right" v-if="edited_rent.amount.value">${{transaction_fees.stripe.card | convertCentsToDollars}}</span>
							<span class="small-4 text-right" v-else>$0</span>
						</p>
						<p class="small-12 flex vertical-align" v-if="company.attributes.settings.payment_methods.ach">
							<b class="small-8 text-right">Stripe ACH Fee:</b> 
							<span class="small-4 text-right" v-if="edited_rent.amount.value">${{transaction_fees.stripe.ach | convertCentsToDollars}}</span>
							<span class="small-4 text-right" v-else>$0</span>
						</p>
						<p class="small-12 flex vertical-align">
							<b class="small-8 text-right">Nestd Fee:</b> 
							<span class="small-4 text-right" v-if="edited_rent.amount.value">${{transaction_fees.platform | convertCentsToDollars}}</span>
							<span class="small-4 text-right" v-else>$0</span>
						</p>
						<div class="small-12 totals border-top">
							<p class="small-12 flex vertical-align total" v-if="company.attributes.settings.payment_methods.cards">
								<b class="small-8 text-right">Total for Card Payment:</b> 
								<span class="small-4 text-right" v-if="edited_rent.amount.value">${{transaction_fees.stripe.card + transaction_fees.platform | convertCentsToDollars}}</span>
								<span class="small-4 text-right" v-else>$0</span>
							</p>
							<p class="small-12 flex vertical-align total" v-if="company.attributes.settings.payment_methods.ach">
								<b class="small-8 text-right">Total for ACH Payment:</b> 
								<span class="small-4 text-right" v-if="edited_rent.amount.value">${{transaction_fees.stripe.ach + transaction_fees.platform | convertCentsToDollars}}</span>
								<span class="small-4 text-right" v-else>$0</span>
							</p>
						</div>
					</div>
				</div>
				<fieldset class="small-12 flex inputGroup" v-if="payment_method_set">
					<div class="small-12 flex" style="margin-bottom:16px;" v-if="rent.attributes.term !== 'past'">
						<div class="small-12 large-3 toggle-button">
							<toggle-button v-model="edited_rent.set_policy.value" color="#18bbf7" :sync="true" :labels="{checked: 'Yes', unchecked: 'No'}" :width="90" :height="40" :font-size="14"/>
						</div>
						<div class="labelDefinitions small-12 large-9 columns flex vertical-align">
							<p class="small-12 columns"><b>Set Transaction Fees Policy</b></p>
							<span class="small-12 columns">Would you like to set an electronic payments transaction fee policy?</span>
						</div>
					</div>
					<div class="small-12 prorated animated fadeIn" v-if="edited_rent.set_policy.value">
						<label class="small-12">Who's responsible for the fees?</label>
						<div class="small-12 selectContainer borderRadius8 flex vertical-align" v-if="rent_options && rent.attributes.term !== 'past'">
							<select name="rent_cycle" class="small-12" v-model="edited_rent.method_type.value" @change="chooseTransactionFeeMethod($event)">
								<option :value="null" selected disabled>Please Choose...</option>
								<option :value="option.value" v-for="(option, index) in rent_options.transaction_fees_options" :key="index" :selected="edited_rent.method_type.value == option.value ? true : false">{{option.title}}</option>
							</select>
						</div>
						<input type="text" class="disabled" disabled v-model="edited_rent.method_type.display_value" v-else>
						<div class="small-12" v-if="show_transaction_fee_amount">
							<label class="small-12">Transaction Fee Amount<em class="cRed">*</em></label>
							<div class="small-12 addOnContainer borderRadius8">
								<input class="inputAddition" type="number" step="0.01" name="custom_transaction_fee_amount" @keyup="transactionFeeValidation()" v-model="edited_rent.fee_amount.value" @input="calculateEstimatedFees()" v-if="rent.attributes.term !== 'past'">
								<input class="inputAddition disabled" type="number" step="0.01" name="custom_transaction_fee_amount" disabled v-model="edited_rent.fee_amount.value" v-else>
								<div class="add-on borderRadius8">
									<i class="material-icons-outlined">attach_money</i>
								</div>
							</div>
						</div>
						<div class="small-12 inputError flex animated fadeInDown" style="margin-top:5px;" v-if="edited_rent.fee_amount.error.show">
							<small class="cRed small-12">{{edited_rent.fee_amount.error.title}}</small>
						</div>
					</div>
				</fieldset>
				<div class="small-12 sectionTitle flex" v-if="rent.attributes.term !== 'past'">
					<h2>Proration</h2>
				</div>
				<fieldset class="small-12 flex inputGroup" v-if="rent.attributes.term !== 'past'">
					<div class="small-12 flex" style="margin-bottom:16px;">
						<div class="small-12 large-3 toggle-button">
							<toggle-button v-model="edited_rent.prorated" color="#18bbf7" :sync="true" :labels="{checked: 'Yes', unchecked: 'No'}" :width="90" :height="40" :font-size="14"/>
						</div>
						<div class="labelDefinitions small-12 large-9 columns flex vertical-align">
							<p class="small-12 columns"><b>Prorate First Month</b></p>
							<span class="small-12 columns">Would you like to prorate the first month?</span>
						</div>
					</div>
					<div class="small-12 prorated animated fadeIn" v-if="edited_rent.prorated">
						<label class="small-12">First Month's Rent<em class="cRed">*</em> ({{proratedDays}} Days)</label>
						<div class="small-12 addOnContainer borderRadius8">
							<input class="readOnly inputAddition" type="number" step="0.01" name="prorated_rent_amount" disabled v-model="edited_rent.first_month_charge_amount.value">
							<div class="add-on borderRadius8">
								<i class="material-icons-outlined">attach_money</i>
							</div>
						</div>
					</div>
				</fieldset>
			</div>
		</div>
		<div class="small-12 columns panelActions flex justify-center vertical-align border-top">
			<a class="blueButton borderRadius4 flex justify-center vertical-align" @click="updateRentTerm()" v-if="enableUpdateButton && rent.attributes.term !== 'past'">
                <i class="material-icons-outlined addIcon borderRadius4 flex justify-center vertical-align">save</i>
                Save Rent Term
            </a>
            <a class="disabledButton borderRadius4 flex justify-center vertical-align" v-else>
                <i class="material-icons-outlined addIcon borderRadius4 flex justify-center vertical-align">save</i>
                Save Rent Term
            </a>
            <a class="deleteButton borderRadius4 flex justify-center vertical-align" v-if="enableDeleteButton" @click="deleteRentTermHandler()">
                Delete Rent Term
            </a>
            <a class="deleteButton disabled borderRadius4 flex justify-center vertical-align" v-else>
                Delete Rent Term
            </a>
		</div>
	</div>
</template>

<script>

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
    import { SpinnerMethods } from '@/mixins/helpers/SpinnerMethods'

    // Import the components
    import { Datetime } from 'vue-datetime'

    // Import the filters
    import { DatesFilters } from '@/mixins/filters/DatesFilters'
	import { MoneyConversions } from '@/mixins/filters/MoneyConversions'
	import { AbbreviateNumbersFilters } from '@/mixins/filters/AbbreviateNumbersFilters'

    // Import the events
	import { GetRentOptions } from '@/events/config/GetRentOptions'
    import { GetRentTermInvoices } from '@/events/invoices/GetRentTermInvoices'
	import { UpdateRentTerm } from '@/events/rent/UpdateRentTerm'
	import { DeleteRentTerm } from '@/events/rent/DeleteRentTerm'
	import { GetFutureRentTerms } from '@/events/rent/GetFutureRentTerms'
	import { GetCurrentRentTerms } from '@/events/rent/GetCurrentRentTerms'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'EditRentMenu',

		/*
		**  Register the components
		*/

		components: {

			datetime: Datetime

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService,
            SpinnerMethods,
            DatesFilters,
            GetRentOptions,
            GetRentTermInvoices,
			MoneyConversions,
			AbbreviateNumbersFilters,
			UpdateRentTerm,
			DeleteRentTerm,
			GetFutureRentTerms,
			GetCurrentRentTerms

		],

		/*
		**  Set the props
		*/

		props: {

			menu_action: {
                type: Boolean,
                default: false
            },

            rent: {
                type: Object,
                default: () => null
            },

			company: {
                type: Object,
                default: () => null
            },

			rents: {
				type: Array,
				default: []
			},

			property: {
				type: Object,
				default: () => null
			},

			lease: {
				type: Object,
				default: () => null
			}

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			open_menu: false,
			processing: false,
			proratedDays: 0,
			due_on: null,
			enableUpdateButton: false,
			enableDeleteButton: false,
            invoices_created: false,
			payment_method_set: false,
			show_transaction_fee_amount: false,
			form_error: false,
			current_rent: null,
			paid_pending_invoices: null,
			transaction_fees: {
				stripe: {
					card: 0,
					ach: 0
				},
				platform: 0
			},
            edited_rent: {
                term: {
                    value: null,
					display_value: null,
                    error: {
                        title: null,
                        show: false
                    }
                },
                status: {
                    value: null,
					display_value: null,
                    error: {
                        title: null,
                        show: false
                    }
                },
                starting_at: {
                    value: null,
					display_value: null,
                    error: {
                        title: null,
                        show: false
                    }
                },
                ending_at: {
                    value: null,
					display_value: null,
                    error: {
                        title: null,
                        show: false
                    }
                },
				amount: {
                    value: null,
					display_value: null,
                    error: {
                        title: null,
                        show: false
                    }
                },
				cycle: {
                    value: null,
					display_value: null,
                    error: {
                        title: null,
                        show: false
                    }
                },
				due_on: {
                    value: null,
					display_value: null,
                    error: {
                        title: null,
                        show: false
                    }
                },
				late_by: {
                    value: null,
					display_value: null,
                    error: {
                        title: null,
                        show: false
                    }
                },
				days_in_advance: {
                    value: null,
					display_value: null,
                    error: {
                        title: null,
                        show: false
                    }
                },
				late_fee: {
                    value: null,
					display_value: null,
                    error: {
                        title: null,
                        show: false
                    }
                },
				set_policy: {
                    value: false,
					display_value: false,
                    error: {
                        title: null,
                        show: false
                    }
                },
				method_type: {
                    value: null,
					display_value: null,
                    error: {
                        title: null,
                        show: false
                    }
                },
				fee_amount: {
                    value: 0,
					display_value: 0,
                    error: {
                        title: null,
                        show: false
                    }
                },
				total_charges: 0,
				prorated: false,
				first_month_charge_amount: {
					value: 0,
					display_value: 0,
                    error: {
                        title: null,
                        show: false
                    }
				},
				total_balance: 0,
				outstanding_balance: 0
            }

		}),

		/*
		**  Watch em'
		*/

		watch: {

			menu_action: {

				immediate: true, // Load on created
				handler(menu_action) {

					/*
					**  Open the menu
					**  @method: @here
					*/

					if (menu_action) this.openTheMenu();

				}

			},

			rent: {

				immediate: true, // Load on created
				handler(rent) {

					/*
                    **  Reset validation props
                    **  @method: @here
                    */

                    this.resetValidationProps();

					/*
                    **  Reset rent invoices
                    **  @prop: Events/Invoices/GetRentTermInvoices
                    */

				   	if (rent) this.rent_invoices = [];

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    if (rent) this.edited_rent.term.value = this.rent.attributes.term;

                    /*
                    **  Check if invoices have been created
                    **  @method: @here
                    */

                    if (rent) this.getRentTermInvoicesHandler(rent.id);

                    /*
                    **  Set the form props
                    **  @method: @here
                    */

                    if (rent) this.setEditRentFormProps();

					/*
                    **  Set the transaction fee
                    **  @prop: @here
                    */

					if (rent) this.show_transaction_fee_amount = true;

					/*
                    **  Get the future and current property rent terms
                    **  @prop: @here
                    */

					if (rent) this.getFutureRentTermsHandler(rent.relationships.property);
					if (rent) this.getCurrentRentTermsHandler(rent.relationships.property);

					/*
                    **  Calculate the charges
                    **  @method: @here
                    */

					this.calculateCharges();

				}

            },

			rent_invoices: {

				immediate: true, // Load on created
				handler(rent_invoices) {

					/*
                    **  Reset delete button
                    **  @prop: @here
                    */

				   	this.enableDeleteButton = false;

                    /*
                    **  If invoices exist
                    */

                    if (rent_invoices && rent_invoices.length > 0) {

						/*
						**  Set the props
						**  @method: @here
						*/

						this.setInvoicesProps();

						/*
						**  Check invoices and eligibility to delete
						**  @method: @here
						*/

						this.checkDeleteEligibility();

					}

					/*
                    **  If no invoices, enable delete button
                    **  @method: @here
                    */

				   	if (!rent_invoices || rent_invoices.length == 0) this.activateDeleteButton();

				}

            },

			company: {

				immediate: true, // Load on created
				handler(company) {

					/*
					**  Check if payment methods have been set
					**  @method: @here
					*/

					if (company) this.checkPaymentMethods();

				}

			},

			edited_rent_term: {

				immediate: true, // Load on created
				handler(edited_rent_term) {

					/*
					**  Rent term validation
					**  @method: @here
					*/

					if (edited_rent_term) this.termValidation();

				}

			},

			edited_rent_starting_at: {

				immediate: true, // Load on created
				handler(edited_rent_starting_at) {

					/*
					**  Rent term validation
					**  @method: @here
					*/

					if (edited_rent_starting_at) this.termDatesValidation();

				}

			},

			edited_rent_ending_at: {

				immediate: true, // Load on created
				handler(edited_rent_ending_at) {

					/*
					**  Term dates validation
					**  @method: @here
					*/

					if (edited_rent_ending_at) this.termDatesValidation();

				}

			},

			edited_rent_amount: {

				immediate: true, // Load on created
				handler(edited_rent_amount) {

					/*
					**  Amount validation
					**  @method: @here
					*/

					if (edited_rent_amount) this.amountValidation();

				}

			},

			edited_rent_late_fee: {

				immediate: true, // Load on created
				handler(edited_rent_late_fee) {

					/*
					**  Late fee validation
					**  @method: @here
					*/

					if (edited_rent_late_fee) this.lateFeeValidation();

				}

			},

			edited_rent_transaction_fee: {

				immediate: true, // Load on created
				handler(edited_rent_transaction_fee) {

					/*
					**  Transaction fee validation
					**  @method: @here
					*/

					if (edited_rent_transaction_fee) this.transactionFeeValidation();

				}

			},

			edited_rent_set_policy: {

				immediate: true, // Load on created
				handler(edited_rent_set_policy) {

					/*
					**  Reset transaction fee policy validation fields
					**  @method: @here
					*/

					this.resetTransactionFeePolicyFields();

				}

			},

			rents: {

				immediate: true, // Load on created
				handler(rents) {

					if (rents && rents.length > 0) {

						/*
						**  Check if another current rent term exists
						*/

						 this.current_rent = this.rents.filter(rent => {

							return rent.attributes.term == 'current';

						});

					}

				}

			}

		},

		/*
        ** Do this first
        */

        mounted() {

        	/*
			**  Get the rent config options
			**  @event: Events/Config/GetRentOptions
			*/

        	this.getRentOptionsHandler();

        },

        /*
		**  Set up the methods
		*/

		methods: {

			openTheMenu: function() {

				try {

					/*
					**  Display the menu
					**  @prop: @here
					*/

					this.open_menu = true;
					
					/*
                    **  Reset validation props
                    **  @method: @here
                    */

                    this.resetValidationProps();

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Open the Edit Rent Term Menu.',
                        errorType: 'Application',
                        section: 'Edit Rent Term',
						uid: 'ZYfj1uZ13OmZTdgTgBRi',
                        error: e
                    });

				}

			},

			resetValidationProps: function() {

                try {

                    /*
                    **  Reset the props
                    **  @props: @here
                    */

                    this.enableUpdateButton = false;
					this.enableDeleteButton = false;
                    this.invoices_created = false;
					this.show_transaction_fee_amount = false;
					this.form_error = false;
                    this.edited_rent = {
                        term: {
                            value: null,
							display_value: null,
                            error: {
                                title: null,
                                show: false
                            }
                        },
                        status: {
                            value: null,
							display_value: null,
                            error: {
                                title: null,
                                show: false
                            }
                        },
                        starting_at: {
                            value: null,
							display_value: null,
                            error: {
                                title: null,
                                show: false
                            }
                        },
                        ending_at: {
                            value: null,
							display_value: null,
                            error: {
                                title: null,
                                show: false
                            }
                        },
						amount: {
							value: null,
							display_value: null,
							error: {
								title: null,
								show: false
							}
						},
						cycle: {
							value: null,
							display_value: null,
							error: {
								title: null,
								show: false
							}
						},
						due_on: {
							value: null,
							display_value: null,
							error: {
								title: null,
								show: false
							}
						},
						late_by: {
							value: null,
							display_value: null,
							error: {
								title: null,
								show: false
							}
						},
						days_in_advance: {
							value: null,
							display_value: null,
							error: {
								title: null,
								show: false
							}
						},
						late_fee: {
							value: null,
							display_value: null,
							error: {
								title: null,
								show: false
							}
						},
						set_policy: {
							value: false,
							display_value: false,
							error: {
								title: null,
								show: false
							}
						},
						method_type: {
							value: null,
							display_value: null,
							error: {
								title: null,
								show: false
							}
						},
						fee_amount: {
							value: 0,
							display_value: 0,
							error: {
								title: null,
								show: false
							}
						},
						total_charges: 0,
						prorated: false,
						first_month_charge_amount: {
							value: 0,
							display_value: 0,
							error: {
								title: null,
								show: false
							}
						},
						total_balance: 0,
						outstanding_balance: 0,
                    };

                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Reset the validation props for the edit rent menu.',
						errorType: 'Application',
						section: 'Edit Rent Term',
						uid: 'C90Nv0021ENiQMTQb7Ry',
						error: e
					});

                }

            },

			closeEditRentMenu: function() {

				try {
 
					/*
                    **  Close the menu
					**  @prop: @here
					*/

					this.open_menu = false;

					/*
                    **  Emit the event
					**  @service: @Vue
					*/

					this.$emit('closeEditRentMenu', true);

					/*
                    **  Reset the prop
					**  @method: @here
					*/

					this.resetValidationProps();

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Close the Edit Rent Term Menu.',
                        errorType: 'Application',
                        section: 'Edit Rent Menu',
						uid: 'jKRF2kjvDM51VU9uV8zs',
                        error: e
                    });

				}

			},

			checkPaymentMethods: function() {

				/*
				**  Check if payment methods have been set
				**  @prop: @here
				*/

				try {

					if (this.company.attributes.settings.payment_methods.cards || this.company.attributes.settings.payment_methods.ach) this.payment_method_set = true;

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Check if payment methods have been set in the Edit Rent Term Menu.',
                        errorType: 'Application',
                        section: 'Edit Rent Menu',
						uid: 'CoOV2mI8BSsvthyXELev',
                        error: e
                    });

				}

			},

			setEditRentFormProps: function() {

                try {

                    /*
                    **  Set the term dates props
                    **  @props: @here
                    */

                    this.edited_rent.starting_at.value = moment(this.rent.attributes.term_dates.starting_at * 1000).format();
					this.edited_rent.starting_at.display_value = moment(this.rent.attributes.term_dates.starting_at * 1000).format('MM/DD/YYYY');
                    this.edited_rent.ending_at.value = moment(this.rent.attributes.term_dates.ending_at * 1000).format();
					this.edited_rent.ending_at.display_value = moment(this.rent.attributes.term_dates.ending_at * 1000).format('MM/DD/YYYY');
					
					/*
                    **  Set the amount props
                    **  @props: @here
                    */

					this.edited_rent.amount.value = (this.rent.attributes.amount / 100).toFixed(2);
					this.edited_rent.amount.value = Number(this.edited_rent.amount.value);
					this.edited_rent.amount.display_value = Number(this.rent.attributes.amount / 100).toFixed(2);

					/*
                    **  Set the proration props
                    **  @props: @here
                    */

					this.edited_rent.prorated = this.rent.attributes.first_month.prorated;
					this.edited_rent.first_month_charge_amount.value = this.rent.attributes.first_month.charge_amount;
					this.edited_rent.first_month_charge_amount.display_value = Number(this.rent.attributes.first_month.charge_amount / 100).toFixed(2);
					
					/*
                    **  Set the cycle props
                    **  @props: @here
                    */
					
					this.edited_rent.cycle.value = this.rent.attributes.policy.cycle;
					if (this.rent.attributes.policy.cycle == 'monthly') this.edited_rent.cycle.display_value = 'Monthly';

					/*
                    **  Set the due on props
                    **  @props: @here
                    */
					
					this.edited_rent.due_on.value = this.rent.attributes.policy.due_on;
					this.edited_rent.due_on.display_value = this.ordinal_suffix(this.rent.attributes.policy.due_on);
					
					/*
                    **  Set the late by props
                    **  @props: @here
                    */
					
					this.edited_rent.late_by.value = this.rent.attributes.policy.late_by;
					this.edited_rent.late_by.display_value = this.ordinal_suffix(this.rent.attributes.policy.late_by);
					
					/*
                    **  Set the days in advance props
                    **  @props: @here
                    */

					this.edited_rent.days_in_advance.value = this.rent.attributes.due_notification.days_in_advance;
					this.edited_rent.days_in_advance.display_value = this.rent.attributes.due_notification.days_in_advance;
					
					/*
                    **  Set the late fee props
                    **  @props: @here
                    */
					
					this.edited_rent.late_fee.value = (this.rent.attributes.policy.late_fee / 100).toFixed(2);
					this.edited_rent.late_fee.value = Number(this.edited_rent.late_fee.value);
					this.edited_rent.late_fee.display_value = (this.rent.attributes.policy.late_fee / 100).toFixed(2);
					
					/*
                    **  Set the transaction fee policy props
                    **  @props: @here
                    */
					
					this.edited_rent.set_policy.value = this.rent.attributes.transaction_fees_policy.set_policy;
					this.edited_rent.set_policy.display_value = this.rent.attributes.transaction_fees_policy.set_policy;
					this.edited_rent.method_type.value = this.rent.attributes.transaction_fees_policy.method_type;
					if (this.rent.attributes.transaction_fees_policy.method_type == 'resident') this.edited_rent.method_type.display_value = 'Resident';
					if (this.rent.attributes.transaction_fees_policy.method_type == 'owner') this.edited_rent.method_type.display_value = 'Owner';
					this.edited_rent.fee_amount.value = (this.rent.attributes.transaction_fees_policy.resident.fee_amount / 100).toFixed(2);
					this.edited_rent.fee_amount.value = Number(this.edited_rent.fee_amount.value);
					this.edited_rent.fee_amount.display_value = Number(this.rent.attributes.transaction_fees_policy.resident.fee_amount / 100).toFixed(2);

					/*
                    **  Calculate the estimated fees
                    **  @method: @here
                    */

					this.calculateEstimatedFees();

                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Set the form props for the edit rent modal.',
						errorType: 'Application',
						section: 'Edit Rent',
						uid: 'HtmtqCpoEYxMAVMsqhMf',
						error: e
					});

                }

            },

            setInvoicesProps: function() {

                try {

                    /*
                    **  Set the invoices_created prop
                    **  @prop: @here
                    */

                    this.invoices_created = true;

                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Set the invoice props for the edit rent modal.',
						errorType: 'Application',
						section: 'Edit Rent',
						uid: 'bMueKPYH4Mh4VArEjTA4',
						error: e
					});

                }

            },

			ordinal_suffix: function(i) {

				try {

					/*
					**  Set the vars
					*/

					let j = i % 10,
        				k = i % 100;
					
					/*
					**  If ends in 1
					*/

					if (j == 1 && k != 11) {
						return i + "st";
					}

					/*
					**  If ends in 2
					*/

					if (j == 2 && k != 12) {
						return i + "nd";
					}

					/*
					**  If ends in 3
					*/

					if (j == 3 && k != 13) {
						return i + "rd";
					}

					/*
					**  Else
					*/
    				
					return i + "th";

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Set the ordinal suffix for dates within the edit rent modal.',
						errorType: 'Application',
						section: 'Edit Rent',
						uid: 'C6BmcUR1wRge2AeAJyvD',
						error: e
					});

				}

			},

			termValidation: function(value) {

				try {

					/*
					**  Set the vars
					*/

					let today = moment().unix(),
						start_date = moment(this.edited_rent.starting_at.value).unix(),
						is_after = moment(start_date).isAfter(today);

					/*
					**  If in the future, check if term start date is in the future
					*/

					if (value == 'future' && !is_after) {

						/*
						**  Set the error props
						**  @props: @here
						*/

						this.edited_rent.term.error.title = 'Your term\'s start date must be in the future if your term type is set to future.'
						this.edited_rent.term.error.show = true;

					} else if (this.rents.length > 0 && this.edited_rent.term.value == 'current' && this.rent.attributes.term !== 'current') {

						/*
						**  If one is found
						*/

						if (this.current_rent.length > 0) {

							/*
							**  Set the error props
							**  @props: @here
							*/

							this.edited_rent.term.error.title = 'You cannot have more than one rent term in a current status.'
							this.edited_rent.term.error.show = true;

						}

					} else {

						/*
						**  Set the error props
						**  @props: @here
						*/

						this.edited_rent.term.error.title = null;
						this.edited_rent.term.error.show = false;

					}

					/*
					**  Check if we can enable the submit button
					**  @method: @here
					*/

					this.enableSubmitButtonCheck();

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Validate the rent term type.',
						errorType: 'Application',
						section: 'Edit Rent',
						uid: 'GUABTOLd37n6IHtGysR2',
						error: e
					});

				}

			},

            calculateCharges: function(event) {

                try {

					/*
					**  Set the charges
					*/

					if (event && event.target && event.target.value && event.target.value == 'monthly' && this.edited_rent.starting_at.value && this.edited_rent.ending_at.value) {
 
						/*
						**  Set the vars
						*/

						let startDate = moment(this.edited_rent.starting_at.value),
							endDate = moment(this.edited_rent.ending_at.value);

						/*
						**  Set the total charges
						*/

						this.edited_rent.total_charges =  Math.ceil(endDate.diff(startDate, 'months', true));

					} else if (this.edited_rent.cycle.value && this.edited_rent.starting_at.value && this.edited_rent.ending_at.value) {

						/*
						**  Set the vars
						*/

						let startDate = moment(this.edited_rent.starting_at.value),
							endDate = moment(this.edited_rent.ending_at.value);

						/*
						**  Set the total charges
						*/

						this.edited_rent.total_charges =  Math.ceil(endDate.diff(startDate, 'months', true));

					}

					/*
					**  Set the prorated days and totals
					**  @method: @here
					*/

					this.proratedRent;

					/*
					**  Check if we can enable the submit button
					**  @method: @here
					*/

					this.enableSubmitButtonCheck();

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Calculate the Charges for the Edit Rent Term Menu.',
                        errorType: 'Application',
                        section: 'Lease Overview',
						uid: 'TjH05cbLuIHI23z8srbF',
                        error: e
                    });

				}

            },

			calculateEstimatedFees: function() {

				try {
 
					/*
                    **  Calculate difference between transaction fee and total amount
                    */

					let newAmount = (Number(this.edited_rent.fee_amount.value) + Number(this.edited_rent.amount.value)) * 100;
 
					/*
                    **  Calculate the Stripe card fees
					*/

					let stripeCardPercent = Number(process.env.VUE_APP_STRIPE_CARD_FEE_PERCENT) + Number(process.env.VUE_APP_STRIPE_EXPRESS_ACCOUNT_FEE_PERCENT),
						stripeCardCents = Number(process.env.VUE_APP_STRIPE_CARD_FEE_CENTS) + Number(process.env.VUE_APP_STRIPE_EXPRESS_ACCOUNT_FEE_CENTS);
					 
					/*
                    **  Calculate the Stripe ACH fees
					*/

					let stripeACHPercent =  Number(process.env.VUE_APP_STRIPE_ACH_FEE_PERCENT) + Number(process.env.VUE_APP_STRIPE_EXPRESS_ACCOUNT_FEE_PERCENT),
						stripeACHCents = Number(process.env.VUE_APP_STRIPE_EXPRESS_ACCOUNT_FEE_CENTS);
 
					/*
                    **  Set the props
					**  @props: @here
					*/

					this.transaction_fees.stripe.card = (newAmount * stripeCardPercent) + stripeCardCents;
					this.transaction_fees.stripe.ach = (newAmount * stripeACHPercent) + stripeACHCents;
					this.transaction_fees.platform = newAmount * process.env.VUE_APP_PLATFORM_FEE_PERCENT;
					
					/*
					**  Validate the amount
					**  @method: @here
					*/

					this.amountValidation();

					/*
					**  Check if we can enable the submit button
					**  @method: @here
					*/

					this.enableSubmitButtonCheck();

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Calculate the Estimated Fees in the Create Rent Term Menu.',
                        errorType: 'Application',
                        section: 'Lease Overview',
						uid: 'CvzRNCk1D15ezQwmgQZ9',
                        error: e
                    });

				}

			},

			startingAtValidation: function() {

				try {
					
					/*
                    **  Set the vars
                    */

					let endsAt = moment(this.edited_rent.ending_at.value).unix(),
						startsAt = moment(this.edited_rent.starting_at.value).unix(),
						isBetweenStartForward = false,
						isBetweenEndForward = false,
						isBetweenStartReverse = false,
						isBetweenEndReverse = false;

					/*
                    **  Check if other rent terms dates fall within
                    */

					if (this.rents.length > 0) {

						this.rents.forEach(rent_term => {

							if (rent_term.id !== this.rent.id) {

								// Set the vars
								let startingAt = moment(rent_term.attributes.term_dates.starting_at),
									endingAt = moment(rent_term.attributes.term_dates.ending_at);
			
								isBetweenStartForward = moment(startsAt).isBetween(startingAt, endingAt);
								isBetweenEndForward = moment(endsAt).isBetween(startingAt, endingAt);
								isBetweenStartReverse = moment(startingAt).isBetween(startsAt, endsAt);
								isBetweenEndReverse = moment(endingAt).isBetween(startsAt, endsAt);

							}

						});

					}

					/*
                    **  If dates fall between, does not pass
                    */

					if (isBetweenStartForward || isBetweenEndForward || isBetweenStartReverse || isBetweenEndReverse) {

						/*
						**  Set the error props
						**  @props: @here
						*/

						this.edited_rent.starting_at.error.title = 'You cannot have a rent term\'s beginning date fall within another rent term\'s dates.';
						this.edited_rent.starting_at.error.show = true;

					} else {

						/*
						**  Set the error props
						**  @props: @here
						*/

						this.edited_rent.starting_at.error.title = null;
						this.edited_rent.starting_at.error.show = false;

					}

					/*
					**  Check if we can enable the submit button
					**  @method: @here
					*/

					this.enableSubmitButtonCheck();

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Validate the rent term starting at field.',
						errorType: 'Application',
						section: 'Edit Rent',
						uid: '8NRGSZxH99XaK9qXHUUO',
						error: e
					});

				}

			},

			termDatesValidation: function() {

				try {
					
					/*
                    **  Set the vars
                    */

					let endsAt = moment(this.edited_rent.ending_at.value).unix(),
						startsAt = moment(this.edited_rent.starting_at.value).unix(),
						difference = moment(this.edited_rent.starting_at.value).diff(moment(this.edited_rent.ending_at.value), 'days'),
						isBetweenStartForward = false,
						isBetweenEndForward = false,
						isBetweenStartReverse = false,
						isBetweenEndReverse = false;

					/*
                    **  Check if other rent terms dates fall within
                    */

					if (this.rents.length > 0) {

						this.rents.forEach(rent_term => {

							if (rent_term.id !== this.rent.id) {

								// Set the vars
								let startingAt = moment(rent_term.attributes.term_dates.starting_at),
									endingAt = moment(rent_term.attributes.term_dates.ending_at);
			
								isBetweenStartForward = moment(startsAt).isBetween(startingAt, endingAt);
								isBetweenEndForward = moment(endsAt).isBetween(startingAt, endingAt);
								isBetweenStartReverse = moment(startingAt).isBetween(startsAt, endsAt);
								isBetweenEndReverse = moment(endingAt).isBetween(startsAt, endsAt);

							}

						});

					}

					/*
                    **  If dates fall between, does not pass
                    */

					if (isBetweenEndForward || isBetweenEndReverse) {

						/*
						**  Set the error props
						**  @props: @here
						*/

						this.edited_rent.ending_at.error.title = 'You cannot have a rent term\'s ending date fall within another rent term\'s dates.';
						this.edited_rent.ending_at.error.show = true;

					} else if (isBetweenStartForward || isBetweenStartReverse) {

						/*
						**  Set the error props
						**  @props: @here
						*/

						this.edited_rent.starting_at.error.title = 'You cannot have a rent term\'s starting date fall within another rent term\'s dates.';
						this.edited_rent.starting_at.error.show = true;

					} else if (difference > 0) {

						/*
						**  Set the error props
						**  @props: @here
						*/

						this.edited_rent.ending_at.error.title = 'You cannot have a rent term ending date fall before the rent term beginning date.';
						this.edited_rent.ending_at.error.show = true;

					} else {

						/*
						**  Set the error props
						**  @props: @here
						*/

						this.edited_rent.ending_at.error.title = null;
						this.edited_rent.ending_at.error.show = false;
						this.edited_rent.starting_at.error.title = null;
						this.edited_rent.starting_at.error.show = false;

					}

					/*
					**  Check if we can enable the submit button
					**  @method: @here
					*/

					this.enableSubmitButtonCheck();

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Validate the rent term dates fields.',
						errorType: 'Application',
						section: 'Edit Rent',
						uid: '8NRGSZxH99XaK9qXHUUO',
						error: e
					});

				}

			},

			amountValidation: function() {

				try {

					/*
					**  Check if not null, else check if negative
					*/

				   	if (this.edited_rent.amount.value == 0 || this.edited_rent.amount.value == null || this.edited_rent.amount.value == '') {

					   	/*
						**  Set the error props
						**  @props: @here
						*/

						this.edited_rent.amount.error.title = 'Your rent term amount must be entered and be a positive number.';
						this.edited_rent.amount.error.show = true;

				   	} else if (this.edited_rent.amount.value < 0) {

					   	/*
						**  Set the error props
						**  @props: @here
						*/

						this.edited_rent.amount.error.title = 'Your rent term amount must be a positive number.';
						this.edited_rent.amount.error.show = true;

				   	} else {

					   	/*
						**  Set the error props
						**  @props: @here
						*/

						this.edited_rent.amount.error.title = null;
						this.edited_rent.amount.error.show = false;

				   	}

					/*
					**  Check if we can enable the submit button
					**  @method: @here
					*/

					this.enableSubmitButtonCheck();

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Validate the rent term ending at field.',
						errorType: 'Application',
						section: 'Edit Rent',
						uid: 'pT2CbqOgQXF0EBIkH3Ex',
						error: e
					});

				}

			},

			lateFeeValidation: function() {

				try {

					if (this.edited_rent.late_fee.value < 0) {

					   	/*
						**  Set the error props
						**  @props: @here
						*/

						this.edited_rent.late_fee.error.title = 'Your rent term late fee must be a positive number.';
						this.edited_rent.late_fee.error.show = true;

				   	} else {

					   	/*
						**  Set the error props
						**  @props: @here
						*/

						this.edited_rent.late_fee.error.title = null;
						this.edited_rent.late_fee.error.show = false;

				   	}

					/*
					**  Check if we can enable the submit button
					**  @method: @here
					*/

					this.enableSubmitButtonCheck();

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Validate the rent term late fee field.',
						errorType: 'Application',
						section: 'Edit Rent',
						uid: 'a95YmyS1l5Yh8eHpZdAp',
						error: e
					});

				}

			},

			resetTransactionFeePolicyFields: function() {

				try {

					/*
					**  Reset the error props
					**  @props: @here
					*/

					if (!this.edited_rent_set_policy) {

						this.edited_rent.fee_amount.error.title = null;
						this.edited_rent.fee_amount.error.show = false;

					} else {

						/*
						**  Re-run fee amount validation
						**  @method: @here
						*/

						this.transactionFeeValidation();

					}

					/*
					**  Check if we can enable the submit button
					**  @method: @here
					*/

					this.enableSubmitButtonCheck();

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Reset the transaction policy validation fields while editing a rent term.',
						errorType: 'Application',
						section: 'Edit Rent',
						uid: 'lEGZHrgNEYNiIheBDIau',
						error: e
					});	

				}

			},

			transactionFeeValidation: function() {

				try {

					if (this.edited_rent.set_policy.value && this.edited_rent.fee_amount.value < 0) {

						/*
						**  Set the error props
						**  @props: @here
						*/

						this.edited_rent.fee_amount.error.title = 'Your rent term transaction fee must be a positive number.';
						this.edited_rent.fee_amount.error.show = true;

					} else if (this.edited_rent.set_policy.value && this.edited_rent.fee_amount.value.length == 0 || this.edited_rent.set_policy.value && this.edited_rent.fee_amount.value == '') {

						/*
						**  Set the error props
						**  @props: @here
						*/

						this.edited_rent.fee_amount.error.title = 'Your rent term transaction fee is required when setting a transaction fee policy.';
						this.edited_rent.fee_amount.error.show = true;

					} else {

						/*
						**  Set the error props
						**  @props: @here
						*/

						this.edited_rent.fee_amount.error.title = null;
						this.edited_rent.fee_amount.error.show = false;

					}

					/*
					**  Calculate the estimated fees
					**  @method: @here
					*/

					this.calculateEstimatedFees();

					/*
					**  Check if we can enable the submit button
					**  @method: @here
					*/

					this.enableSubmitButtonCheck();

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Validate the rent term transaction fee field.',
						errorType: 'Application',
						section: 'Edit Rent',
						uid: 'iYJRqn7Q8hpYbqECvgeq',
						error: e
					});

				}

			},

			populateDueOn: function() {

				try {

					/*
                    **  Loop through and set the due on title
					**  @prop: @here
					*/

					this.rent_options.due_on.forEach(option => {

						if (option.value == this.edited_rent.due_on.value) this.due_on = option.title;

					});

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Populate the Due On the Edit Rent Term Menu.',
                        errorType: 'Application',
                        section: 'Edit Rent',
						uid: 'nhKqiBNCwQFUAfSZBZ48',
                        error: e
                    });

				}

			},

			chooseTransactionFeeMethod: function(event) {

				try {
 
					/*
                    **  Reset the fields
                    **  @props: @here
                    */

					this.show_transaction_fee_amount = false;
					this.edited_rent.fee_amount.value = 0;

					/*
					**  Reset the error props
					**  @props: @here
					*/

					if (event.target.value !== 'resident') {

						this.edited_rent.fee_amount.error.title = null;
						this.edited_rent.fee_amount.error.show = false;

					}
 
					/*
                    **  If resident pays a custom amount
                    **  @props: @here
                    */

					if (event.target.value == 'resident') this.show_transaction_fee_amount = true;

					/*
                    **  Re-run fee amount validation
                    **  @method: @here
                    */

					if (event.target.value == 'resident') this.transactionFeeValidation();

					/*
					**  Check if we can enable the submit button
					**  @method: @here
					*/

					this.enableSubmitButtonCheck();

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Choose Transaction Fee Method in the Edit Rent Term Menu.',
                        errorType: 'Application',
                        section: 'Edit Rent',
						uid: 'jwOgzIp94DRyqitPb2Ob',
                        error: e
                    });

				}

			},

			enableSubmitButtonCheck: function() {

				try {

					if (!this.edited_rent.term.error.show && !this.edited_rent.status.error.show && !this.edited_rent.starting_at.error.show && !this.edited_rent.ending_at.error.show && !this.edited_rent.amount.error.show && !this.edited_rent.cycle.error.show && !this.edited_rent.due_on.error.show && !this.edited_rent.late_by.error.show && !this.edited_rent.days_in_advance.error.show && !this.edited_rent.late_fee.error.show && !this.edited_rent.set_policy.error.show && !this.edited_rent.method_type.error.show && !this.edited_rent.fee_amount.error.show) {

						/*
						**  Enable the submit button
						**  @prop: @here
						*/

						this.enableUpdateButton = true;

					} else {

						/*
						**  Disable the submit button
						**  @prop: @here
						*/

						this.enableUpdateButton = false;

					}

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Enable Submit Button Check for the Edit Rent Term Menu.',
                        errorType: 'Application',
                        section: 'Edit Rent',
						uid: 'm4oFI30KXmHKJd06iumd',
                        error: e
                    });

				}	

			},

			updateRentTerm: function() {

				try {

					/*
					** Validate
					** @method: @here
					*/

					let validated = this.validate();

					if (!validated) {

						/*
						** Show the message
						** @service: @SweetAlert2
						*/

						this.$swal('Uh Oh!', 'Please fill out all required fields before updating a new rent term.', 'error');

						return;

					}

					/*
					** Update the rent term
					** @event: Events/Rent/UpdateRentTerm
					*/

					this.updateRentTermHandler();

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Run through the pre-update steps when editing the Rent Term.',
                        errorType: 'Application',
                        section: 'Edit Rent',
						uid: 'tTSZLLXDfMJuXSHw02nK',
                        error: e
                    });

				}

			},

			validate: function() {

				try {
 
					/*
                    **  Required fields
                    **  @props: @here
                    */

					if (this.edited_rent.term.value == null) return false;
					if (this.edited_rent.starting_at.value == null || this.edited_rent.starting_at.value.length == 0) return false;
					if (this.edited_rent.ending_at.value == null || this.edited_rent.ending_at.value.length == 0) return false;
					if (this.edited_rent.amount.value == 0 || this.edited_rent.amount.value == null || this.edited_rent.amount.value == '') return false;
					if (this.edited_rent.cycle.value == null) return false;
					if (this.edited_rent.due_on.value == null) return false;
					if (this.edited_rent.cycle.value == null) return false;
					if (this.edited_rent.method_type.value == 'residents' && this.edited_rent.fee_amount.value == 0 || this.edited_rent.method_type.value == 'residents' && this.edited_rent.fee_amount.value == '') return false; 

					return true;

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Validation for the Edit Rent Term Menu.',
                        errorType: 'Application',
                        section: 'Edit Rent',
						uid: 'KV9DIXoIdfp7S7bYC8WV',
                        error: e
                    });

				}

			},

			activateDeleteButton: function() {

				try {

					/*
                    **  Set the prop
                    **  @prop: @here
                    */

				   	this.enableDeleteButton = true;

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Enable the Delete Button for the Edit Rent Term Menu.',
                        errorType: 'Application',
                        section: 'Edit Rent',
						uid: 'clvPsrTLYYXNYT51TnzO',
                        error: e
                    });

				}

			},

			checkDeleteEligibility: function() {

				try {

					/*
					**  Check if any invoices have been paid
					*/

					this.paid_pending_invoices = this.rent_invoices.filter(invoice => {

						return invoice.attributes.status == 'paid' || invoice.attributes.status == 'pending';

					});

					/*
					**  If paid or pending, disable the delete button
					**  @prop: @here
					*/

					if (this.paid_pending_invoices && this.paid_pending_invoices.length > 0) {

						this.enableDeleteButton = false;

					} else {

						/*
						**  Else, enable delete
						**  @prop: @here
						*/

						this.enableDeleteButton = true;

					}

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Check if Invoice id Eligible to be Deleted for the Edit Rent Term Menu.',
                        errorType: 'Application',
                        section: 'Edit Rent',
						uid: '8legld6WGxBS40mQuVOD',
                        error: e
                    });

				}

			},

			setCalendarPickerIndex: function(event) {

                try {

                    /*
					**  Emit the event
					**  @service: @Vue
					*/

                    this.$emit('setCalendarPickerIndex', true);
                    
                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Emit the set calendar picker index event.',
						errorType: 'Application',
						section: 'Edit Rent Menu',
						uid: 'mEvfIGSOopRpQFfkkucS',
						error: e
					});

                }

            },

		},

		/*
		**  Set the computed props
		*/

		computed: {

			edited_rent_term: function() {

				return this.edited_rent.term.value;

			},

			edited_rent_starting_at: function() {

				return this.edited_rent.starting_at.value;

			},

			edited_rent_ending_at: function() {

				return this.edited_rent.ending_at.value;

			},

			edited_rent_amount: function() {

				return this.edited_rent.amount.value;

			},

			edited_rent_late_fee: function() {

				return this.edited_rent.late_fee.value;

			},

			edited_rent_transaction_fee: function() {

				return this.edited_rent.fee_amount.value;

			},

			edited_rent_set_policy: function() {

				return this.edited_rent.set_policy.value;

			},

			proratedRent: function() {

				if (!this.processing && moment(this.edited_rent.starting_at.value).isValid()) {

					if (this.edited_rent.amount.value > 0 && this.edited_rent.starting_at.value) {

						/*
						**  Set the vars
						*/

						let startDate = moment(this.edited_rent.starting_at.value).format('DD'),
							totalDaysInMonth = moment(this.edited_rent.starting_at.value).daysInMonth(),
							daysRemaining = totalDaysInMonth - startDate; 

						/*
						**  Calculate days since lease beginning date
						*/

						let amount = ((this.edited_rent.amount.value / totalDaysInMonth) * daysRemaining).toFixed(2);
 
						/*
						**  Add to props
						*/

						this.edited_rent.first_month_charge_amount.value = Number(amount);
						this.proratedDays = daysRemaining;

					} else {

						/*
						**  Add to props
						*/

						this.edited_rent.first_month_charge_amount.value = 0;
						this.proratedDays = 0;

					}

				}

				/*
				**  Calculate the estimated fees
				**  @method: @here
				*/

				this.calculateEstimatedFees();

			}

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>